import React from "react";
import { Box, Divider, Tab, Tabs } from "@mui/material";
import { NavLink, Outlet, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useOrder } from "../../hooks/useOrder";
import OrderHeader from "./OrderHeader";

function OrderDetailsTabs() {
  const { t } = useTranslation();
  const { trackingCode } = useParams();
  const location = useLocation();
  const path = location.pathname;
  const { order, loading, archiveOrder, unarchiveOrder, deleteOrder } = useOrder(trackingCode);

  const contextValue = {
    order,
    loading,
  };

  const TabsContainer = ({ className }) => {
    return (
      <Tabs value={path} aria-label="order details tabs" className={className}>
        <Tab
          label={t("orderTracking.orderDetails")}
          component={NavLink}
          to={`/orders/${trackingCode}/`}
          value={`/orders/${trackingCode}/`}
          className={"smMax:w-1/2"}
        />
        <Divider orientation={"vertical"} flexItem />
        <Tab
          label={t("orderTracking.deliveryStatus")}
          component={NavLink}
          to={`/orders/${trackingCode}/status`}
          value={`/orders/${trackingCode}/status`}
          className={"smMax:w-1/2"}
        />
      </Tabs>
    );
  };

  return (
    <Box className={"shadow-md rounded-md mb-5"}>
      <TabsContainer className={"md:hidden w-full"} />
      <Divider orientation={"horizontal"} flexItem className={"md:hidden"} />
      <OrderHeader
        order={order}
        archiveOrder={archiveOrder}
        unarchiveOrder={unarchiveOrder}
        deleteOrder={deleteOrder}
      />
      <Divider orientation={"horizontal"} flexItem className={"smMax:hidden"} />
      <TabsContainer className={"mx-2 smMax:hidden"} />
      <Divider orientation={"horizontal"} flexItem className={"smMax:hidden"} />
      <Outlet context={contextValue} />
    </Box>
  );
}

export default OrderDetailsTabs;
